/**
 * Copying an existing fixture forward into a new product (#805).
 *
 * Most Product Update forms exist to create a "-2": a new item that is the old
 * one revised. Everything physical carries over — dimensions, specs, supplier —
 * so it should not be retyped. What must NOT carry over is anything that
 * identifies the source item, or that describes where the source item is in its
 * own life rather than what the fixture is.
 */
export const FIELDS_NEVER_COPIED = [
    // Unique to each physical item. Copying these is exactly the fault the #228
    // UPC audit found: 46 live products carrying another fixture's UPC.
    'upcCode',
    'masterpackUpcCode',
    'euUkUpcCode',
    'publishedEuUkUpcCode',
    'itemCode',
    'sku',
    'barcodeImage',
    // The new item's own identity, which the person creating it fills in.
    'name',
    'itemNumber',
    // The source item's lifecycle. A "-2" starts its own; it must not open as
    // Discontinued, or Launched, or with the source's batch already shipped.
    'productStatus',
    'status',
    'phase',
    'lifeStatus',
    'euLifeStatus',
    'targetLaunchDate',
    'batch1ProductionStatus',
    'sparesPricingStatus',
    'addToPriceList',
    // What replaced the SOURCE says nothing about the new item.
    'replacementTo',
    // Record-keeping about the source record, not facts about the fixture.
    'fieldHistory',
    'createdAt',
    'createdBy',
    'updatedAt',
    'updatedBy',
    'fromSmartSheet',
];
const NEVER = new Set(FIELDS_NEVER_COPIED);
/**
 * The source product's metadata that a new product copied from it may keep,
 * plus `replacedItem` pointing back at the source — the "-2" records what it
 * replaces. Empty values are dropped so they never mask a default.
 */
export function copyableMetadata(source) {
    const out = {};
    for (const [key, value] of Object.entries(source)) {
        if (NEVER.has(key))
            continue;
        if (value === undefined || value === null || value === '')
            continue;
        out[key] = value;
    }
    const sourceName = typeof source.name === 'string' ? source.name.trim() : '';
    if (sourceName)
        out.replacedItem = sourceName;
    return out;
}
//# sourceMappingURL=product-copy.js.map